import Image from "@Components/Image";
import { SectionBasic } from "@Components/ui/section";
import { CMSImageType } from "@Types/Contentful";
import Link from "@wff/components/Link";
import classes from "./Educational.module.scss";

interface EducationalProps {
  heading: string;
  paragraph: string;
  buttonText: string;
  buttonLink: string;
  image: CMSImageType;
  mobileImage: CMSImageType;
}

const Educational = ({
  heading,
  paragraph,
  buttonText,
  buttonLink,
  image,
  mobileImage,
}: EducationalProps) => {
  const ActionButton = buttonText ? (
    <Link href={buttonLink}>
      <a className="action action--primary">{buttonText}</a>
    </Link>
  ) : null;

  const manageListOfQuotes = (paragraph: any) => {
    paragraph = paragraph.json.content[0].content[0].value.split(".");
    const listOfQuotes: string[] = [];
    paragraph.forEach((quote: string) => {
      listOfQuotes.push(quote.slice(0, quote.length - 1));
    });
    listOfQuotes.pop();
    listOfQuotes.shift();
    return listOfQuotes;
  };
  const listOfQuotes = manageListOfQuotes(paragraph);

  return (
    <SectionBasic
      heading={heading}
      paragraph={listOfQuotes}
      isList={true}
      button={ActionButton}
      className={`section ${classes.educational}`}
      backgroundImage={`${image?.url}?fm=webp&w=1920&h=1080`}
      backgroundImageClassName={classes["educational__background"]}
      paragraphClassName={classes["educational__paragraph"]}
    >
      <Image
        src={mobileImage?.url && `${mobileImage?.url}?fm=webp&w=1920&h=1080`}
        width={mobileImage?.width}
        height={mobileImage?.height}
        alt={mobileImage?.title}
        className={classes["educational__image"]}
      />
    </SectionBasic>
  );
};

export default Educational;
